import { render, staticRenderFns } from "./PriviewImg.vue?vue&type=template&id=499ce6f6&scoped=true&"
import script from "./PriviewImg.vue?vue&type=script&lang=js&"
export * from "./PriviewImg.vue?vue&type=script&lang=js&"
import style0 from "./PriviewImg.vue?vue&type=style&index=0&id=499ce6f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499ce6f6",
  null
  
)

export default component.exports